import Button from "@mecha/design-components/dist/src/components/Elements/Button";
import { observer } from "mobx-react";
import { useStore } from "../../../storeManager/stores";

const ApiKeyHeader = () => {
  const { setApiKeyModal, apiKeyList } = useStore().settingsStore;
  return (
    <div className="w-full flex flex-col gap-5">
      <div className="flex justify-end items-center">
        {/* <p className="text-web-h6 font-medium dark:text-dark-n-400 text-light-n-400">
          API Keys
        </p> */}
        <div>
          <p className="text-web-b4 dark:text-dark-n-400 text-light-n-400">
            Generate secure API Keys to authenticate the Mecha Developer CLI
            (link) and our REST APIs (link). You can use both these tools to
            build custom applications and workflows that integrate with Mecha.
          </p>
        </div>
      </div>
      <div>
        <Button
          size="m"
          className="__button-generate-new-api-key"
          onClick={() => {
            setApiKeyModal(true);
          }}
        >
          Generate key
        </Button>
      </div>
    </div>
  );
};

export default observer(ApiKeyHeader);
